import { FieldTypeAsset } from '@allesauto/utils/*';
import clsx from 'clsx';

enum Position {
  RIGHT = 'right',
  LEFT = 'left',
}

enum BackgroundColors {
  RED = 'red',
  GREY = 'grey',
  WHITE = 'white',
}

type DownloadPdfButtonProps = {
  position: Position;
  label: string;
  file: FieldTypeAsset;
  backgroundColor: BackgroundColors;
};

const classNames = {
  [Position.LEFT]: {
    [BackgroundColors.RED]: 'bg-red60 text-white col-start-2',
    [BackgroundColors.GREY]: 'bg-grey80 text-white col-start-2',
    [BackgroundColors.WHITE]: 'bg-grey80 text-black col-start-2',
  },
  [Position.RIGHT]: {
    [BackgroundColors.RED]: 'bg-red60 text-white float-right',
    [BackgroundColors.GREY]: 'bg-grey80 text-white float-right',
    [BackgroundColors.WHITE]: 'bg-white text-black float-right',
  },
  container: 'grid grid-cols-24',
  buttonContainer: 'col-start-2 col-end-24',
  button:
    'font-weight-bold h-[50px] inline-flex items-center justify-center rounded-default no-underline sm:px-20px md:px-40px',
};

export default function DownloadPdfButton({
  label,
  position,
  file,
  backgroundColor,
}: DownloadPdfButtonProps) {
  return (
    <div className={classNames.container}>
      <div className={classNames.buttonContainer}>
        <a
          className={clsx(
            classNames.button,
            classNames[position][backgroundColor]
          )}
          href={file.filename}
          download
          rel="noopener noreferrer"
          target="_blank"
        >
          {label}
        </a>
      </div>
    </div>
  );
}
